export const brandLogoStyles = {
  height: '58px',
  width: '122px',
}
